module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/054-canary-islands-b051874d38f5a034eaacaf6aa17e47d9.svg";